export var email = function email(centralApi) {
  return {
    post: function post(data) {
      if (data === void 0) {
        data = null;
      }
      return centralApi.post('/email', data, {
        contentType: false
      });
    }
  };
};